import { HTMLAttributes } from 'react';
import {
  IChildrenProp,
  IJustifyPositionProps,
} from 'types/components/components.interface';
import TableRowItemAddButton from './add-buttons/TableRowItemAddButton';
import TableRowItemAddButtonsWrapper from './add-buttons/TableRowItemAddButtonsWrapper';
import TableRowIcon from './icon/TableRowIcon';
import TableRowItemList from './list/TableRowItemList';
import './TableRowItem.scss';
import TableRowText from './text/TableRowText';
import TableRowCurrency from './currency/TableRowCurrency';
import TableRowImage from './image/TableRowImage';

interface ITableItemProps
  extends IJustifyPositionProps,
    IChildrenProp,
    HTMLAttributes<HTMLDivElement> {
  showOnHover?: boolean;
}

const TableItem = ({
  justifyPosition = 'start',
  children,
  showOnHover = false,
  ...props
}: ITableItemProps) => {
  return (
    <div
      {...props}
      className={`table-row-item  gap-1 hide ${justifyPosition}${
        showOnHover ? ' show-on-hover' : ''
      } ${props.className ?? ''}`}>
      {children}
    </div>
  );
};

TableItem.Currency = TableRowCurrency;
TableItem.Image = TableRowImage;
TableItem.Text = TableRowText;
TableItem.Label = TableRowIcon;
TableItem.List = TableRowItemList;
TableItem.AddButtonsWrapper = TableRowItemAddButtonsWrapper;
TableItem.AddButton = TableRowItemAddButton;

export default TableItem;
